module.exports = __webpack_public_path__ + "static/img/Yummy Recipe.a9fdf92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobizone/imgs/browse/Yummy Recipe.jpg
// module id = 1562
// module chunks = 0